module.exports = __webpack_public_path__ + "media/images/konintodoke/top_recommend/winter-left-icon-eca0c041426f1e0bcc5942ac0b136d7a.svg";